export default {
    name: "Add",
    title: "Add",
    icon: "mdi-plus",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            component: null
        };
    },
};